import React from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, } from '@mui/material';

interface TalkPlanMasterPublishConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const TalkPlanMasterPublishConfirmDialog: React.FC<TalkPlanMasterPublishConfirmDialogProps> = ({
  open,
  onClose,
  onConfirm,
}) => {
  return (
    <Dialog
      open={open}
      onClose={(_event: React.SyntheticEvent, reason?: string) => {
        if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
          onClose();
        }
      }}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          position: 'fixed',
          top: '5%',
          margin: 0,
        }
      }}
    >
      <DialogTitle>対話プランを公開しますか？</DialogTitle>
      <DialogContent>
        <DialogContentText>
          公開設定にすると、このプランが看護師に表示されるようになります。
          <br/>
          <br/>
          この内容で公開してよろしいですか？
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          color="inherit"
        >
          戻る
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          autoFocus
        >
          公開する
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TalkPlanMasterPublishConfirmDialog;
